import { render, staticRenderFns } from "./formAddRegional.vue?vue&type=template&id=274684ae&scoped=true"
import script from "./formAddRegional.vue?vue&type=script&lang=js"
export * from "./formAddRegional.vue?vue&type=script&lang=js"
import style0 from "./formAddRegional.vue?vue&type=style&index=0&id=274684ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274684ae",
  null
  
)

export default component.exports